/* eslint-disable-next-line import/no-unresolved */
import { createContext, createElement, memo, useState } from 'react';

const initialValue = null;
const initialState = [initialValue, () => {}];

export const SelectedStrategyGroupContext = createContext(initialState);

export const SelectedStrategyGroupProvider = memo(({ children }) => {
  const [data, setData] = useState(initialValue);
  return createElement(
    SelectedStrategyGroupContext.Provider,
    { value: [data, setData] },
    ...(Array.isArray(children) ? children : [children]),
  );
});

// SelectedStrategyGroupProvider.propTypes = {
//   children: PropTypes.node.isRequired,
// };
